/*jshint unused:false*/
/*global fetch */
/*global console */



// $(function () {

// /**** NAV SCROLL ****/
//     $(".side-nav a, .header-intro a, .footer-content a").click(function(e){
//         e.preventDefault();
//         // Hide nav
//         // Scroll to location
//         $("html, body").animate({ 
//             scrollTop: $( $(this).attr('href') ).position().top+50
//         }, 600);
//     });

// });

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);


if(ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for(var i=0; i<imgContainer.length; i++){
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}


// Price switch 
function priceswitch(event) {
    event.preventDefault();
    document.getElementById('switch-price-type').value = this.value;
    document.getElementById('price-switch').submit();
}
var price_buttons = document.querySelectorAll("#price-switch button");
for(var i=0; i<price_buttons.length; i++){
  price_buttons[i].addEventListener('click', priceswitch, false);
}


//Nav Toggle
function toggleNav(el) {
    var element = el;
    var menu = document.getElementById("site-menu");
    var header = document.querySelectorAll(".site-header")[0];
    menu.classList.toggle("active");
    header.classList.toggle("active");

    if(element.querySelector("span").classList.contains("more")){
      element.innerHTML = "<span class='close'></span> Close";
    } else {
      element.innerHTML = "<span class='more'></span> Menu";
    }
}

//Accordion active
var showAccordion = function(){
    var dropdown = this.parentNode;
    dropdown.classList.toggle("active");
}

var accordionButton = document.querySelectorAll(".accordion > button, .accordion > a");

for(var i=0; i<accordionButton.length; i++){
  accordionButton[i].addEventListener('click', showAccordion, false);
}

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }

var modalMobileNav = new tingle.modal({
  closeMethods: [],
  cssClass: ['mobile-nav','reversed']
});


const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('.hamburger');
const handleToggle = () => {
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');

  
  if(hamburger.classList.contains("is-active")) {
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});

modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML);


// Search Bar
var searchDropdown = function(){
    var searchRow = this.closest('.search-bar');
    searchRow.classList.toggle("active");
}

var searchBar = document.querySelectorAll(".search-bar .legend");

for(var i=0; i<searchBar.length; i++){
  searchBar[i].addEventListener('click', searchDropdown, false);
}


if(document.getElementsByClassName('toggle-search').length>0){
    document.getElementsByClassName('toggle-search')[0].addEventListener('click', function(e){
      e.preventDefault();
      if(document.querySelector('#popout-form')===null){
        window.location.href='/search?show-search-bar=true';
        return false;
      }
      if(document.querySelector('#popout-form').classList.contains('hidden')){
        document.querySelector('#popout-form').classList.remove('hidden');
      } else {
        document.querySelector('#popout-form').classList.add('hidden');
      }
    });
}



//Menu Dropdown Toggle
// var menuDropdown = function(){
//     var dropdown = this;
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }

// //Dropdown Button
// var showDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var dropdownButton = document.querySelectorAll(".dropdown > button");

// for(var i=0; i<dropdownButton.length; i++){
//   dropdownButton[i].addEventListener('click', showDropdown, false);
// }

// //Dropdown Toggle
// var showDropdown = function(){
//     var dropdown = this.querySelector('div');
//     dropdown.classList.toggle("active");
// }

// var has_dropdown = document.querySelectorAll(".has-dropdown");

// for(var i=0; i<has_dropdown.length; i++){
//   has_dropdown[i].addEventListener('click', showDropdown, false);
// }

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }


// Site Search Toggle
// var searchToggle = function(){
//   search_container = document.querySelector(".popout-form");
//   if(search_container){
//     search_container.classList.toggle("active");
//   } else {
//     var elmnt = document.querySelector(".full-header-search");
//     elmnt.scrollIntoView();
//   }
// }

// var search_toggle = document.getElementById('search-toggle');
// search_toggle.addEventListener('click', searchToggle , false);



//Site Menu Dropdown Toggle
var menuDropdown = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".menu-dropdown.active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
        }
    }
    
    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
}

var dropdownTrigger = document.querySelectorAll(".menu-dropdown > a");

for(var i=0; i<dropdownTrigger.length; i++){
  dropdownTrigger[i].addEventListener('click', menuDropdown, false);
}


// //Menu Dropdown Toggle
// var menuDropdown = function(){
//     //div inside element contains dropdown menu
//     var dropdown = this.parentNode.querySelector(".menu-dropdown");

//     //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     // //get current active class
//     // var activeClass = document.querySelectorAll(".menu-dropdown.active");
//     // // make it not active
//     // if(activeClass!=null){
//     //     for(var i=0; i<activeClass.length; i++){
//     //       activeClass[i].classList.toggle("active");
//     //     }
//     // }
    
//     //apply active to the div inside element that contains dropdown menu
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown > a");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }


//Dropdown Menu Toggle
var showMenu = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode.querySelector('div');
    var menuToggle = this;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        menuToggle.classList.toggle("active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".dropdown-menu .active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
        }
    }
    
    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
    menuToggle.classList.toggle("active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}



//Dropdown Menu Toggle
// var mobileDropdown = function(){
//   //div inside element contains dropdown menu
//   var dropdown = this.parentNode.querySelector('div');


//   //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     //get current active class
//     var activeClass = document.querySelectorAll(".mobile-dropdown .active");
//     // make it not active
//     if(activeClass!=null){
//         for(var i=0; i<activeClass.length; i++){
//           activeClass[i].classList.toggle("active");
//         }
//     }

  
//   //apply active to the div inside element that contains dropdown menu
//   dropdown.classList.toggle("active");
// }

// var mobileMenu = document.querySelectorAll(".mobile-dropdown > a");

// for(var i=0; i<mobileMenu.length; i++){
//   mobileMenu[i].addEventListener('click', mobileDropdown, false);
// }



//faqs
var faqSearch = document.querySelector('.faq-search input');

if(faqSearch !== null){
  faqSearch.addEventListener('keyup', function(e){
    var results = document.getElementById('faq-results');
    if(this.value.length != 0){
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}


//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
	e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  console.log("openTab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
    el.style.display = 'none';
    el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}


/** 
  * SEARCH
  */
function searchType(elem, searchType) {
  var hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");
  loadManufacturers((document.getElementsByName('search-type')[0].value=='car'?'car':'van'));
  loadBodyTypes((document.getElementsByName('search-type')[0].value=='car'?'car':'van'));

  var dropdown = document.getElementsByName('model')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

}


function loadManufacturers($type) {
  // console.log('loadManufacturers')
  if ($type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    let fuel_type = document.querySelector('input[name="fuel_type"]') ? document.querySelector('input[name="fuel_type"]').value : null;
    document.querySelectorAll('select[name="make"]').forEach((v, i) => {
      v.length = 0;
      v.add(loadingOption);
      v.selectedIndex = 0;
      let url = (fuel_type == 'Electric') ? '/api/'+$type+'/manufacturers/ev?available=yes' : '/api/'+$type+'/manufacturers/available';
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        v.length = 0;
        v.add(defaultOption);
        v.selectedIndex = 0;
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]].toUpperCase();
          option.value = keysSorted[x];
          v.add(option);

          // let selectedMake = new URLSearchParams(window.location.search).get('make');
          // if (selectedMake == option.value) {
          //   v.value = selectedMake;
          //   console.log(selectedMake)
          //   console.log('selectedMake')
          // }
        }
        const urlParams = new URLSearchParams(window.location.search);
        const makeDropdown = document.querySelector('select[name="make"]');

        if(urlParams.has('make') && urlParams.get('make') != '' && makeDropdown.length > 0) {
          document.querySelectorAll('select[name="make"]').forEach((v, i) => {
            v.value = urlParams.get('make');
          })
        }

      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    })
  }
}

function loadModels($type, $manufacturer)
{

  var model_dropdowns = document.getElementsByName("model");
  for (i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($manufacturer) {
      var url = '/api/' + $type + '/models/' + $manufacturer;

      fetch(url).then(function (response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function (data) {
        let keysSorted = Object.keys(data).sort(function (a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function (err) {
        console.error('Fetch Error -', err);
      });
    }
  }
}


function loadSpecs($type, $model)
{
  if($type=='van'){
    return;
  }
  if(document.getElementsByName('spec').length==0){
    return;
  }

  var dropdown = document.getElementsByName('spec')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Spec';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  if($model) {
    var url = '/api/' + $type + '/specs/' + $model;

    fetch(url).then(function (response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function (data) {
      let keysSorted = Object.keys(data).sort(function (a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }
    }).catch(function (err) {
      console.error('Fetch Error -', err);
    });
  }
}


function loadBodyTypes($type)
{

  var dropdown = document.getElementsByName('body_type')[0];

  if(typeof dropdown == 'undefined'){
    return false;
  }

  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Bodytype';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/types';

  fetch(url).then(function(response) {  
    if (response.status !== 200) {  
      console.warn('Looks like there was a problem. Status Code: ' + 
        response.status);  
      return;  
    }
    return response.json();
  }).then(function(data) {  
    for (var x in data) {
        var option = document.createElement('option');
        option.text = data[x];
        option.value = x;
        dropdown.add(option);
    }    
  }).catch(function(err) {  
      console.error('Fetch Error -', err);  
  });


}




//Lazy Load Images
document.addEventListener("DOMContentLoaded", function() {

  //preloader
  var root = document.getElementsByTagName( 'html' )[0];
  root.classList.add("site-loaded");

  document.body.classList.add("loaded");

  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;

  const lazyLoad = function() {
    if (active === false) {
      active = true;


      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });

      active = false;
    }
  };

  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();

  //Filter Deals
  const filters = document.querySelector('#offer-filters');
  if (filters){
    filters.querySelectorAll('.form select').forEach((value) => {
      value.addEventListener('change', () => {
        filters.querySelector('#filter-button').click();
      })
    })
  }

  // Header Search Special Offers Button
  const headerSearch = document.querySelector('.full-header-search .search-form');
  if (headerSearch){
    let url = '/van-leasing/special-offers';
    const headerSearchFields = headerSearch.querySelectorAll('select, .search-tab');
    const headerSearchButton = headerSearch.querySelector('.button');
    const headerSearchType = headerSearch.querySelector('#search-type');
    headerSearchFields.forEach((value) => {
      value.addEventListener('click', () => {
        if (headerSearch.querySelector('select[name="make"]').value === '' && headerSearch.querySelector('select[name="budget"]').value === '') {
          (headerSearchType.value == 'van') ? url = '/van-leasing/special-offers' : url = '/special-offers';
        } else  {
          url = '';
        }
      })
    })
    headerSearchButton.addEventListener('click', (ev) => {
      if (url) {
        ev.preventDefault();
        location.href = url;
      }
    })
  }

  //Derivative text labels
  if(document.querySelector('.deal-box-description')){
    let descriptionList = document.querySelector('.deal-box-description ul');
    if (descriptionList.childElementCount < 4) {
      descriptionList.querySelectorAll('li').forEach((value) => {
        value.classList.add('normal');
      });
    }
  }

  //Breadcrumbs toggle
  const breadcrumbs = document.querySelector('.breadcrumbs');
  if(breadcrumbs){
    let lastChild = breadcrumbs.querySelector('li:last-child');
    function addActiveClass(e){
      e.preventDefault();
      breadcrumbs.querySelectorAll('li').forEach((value) => {
        value.classList.add('active');
      })
      lastChild.removeEventListener('click', addActiveClass);
    }
    lastChild.addEventListener('click', addActiveClass);
  }

  // Contact Form
  if(document.getElementById('send-contact-form')){

    let button = document.getElementById('send-contact-form');
    let terms = document.querySelector('.contact-form [name=consent]');
    if(terms) {
      terms.onchange = function() {
        button.disabled = !this.checked;
      };
    }

    // Do captch and submit form
    document.getElementById('send-contact-form').addEventListener("click", function(e) {
      e.preventDefault();

      document.body.classList.remove('loaded');

      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/contact';
          let email = document.querySelector('#contact-form [name=email]').value;
          let name = document.querySelector('#contact-form [name=name]').value;
          let telephone = document.querySelector('#contact-form [name=telephone]').value;
          let comments = document.querySelector('#contact-form [name=comments]').value;
          let token = document.querySelector('#contact-form [name=_token]').value;
          let recaptcha = document.querySelector('input[name=g-recaptcha-response]').value;

          fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              'name': name,
              'email': email,
              'telephone': telephone,
              'comments': comments,
              '_token': token,
              'g-recaptcha-response': recaptcha
            }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.body.classList.add('loaded');
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status!='ok'){
              let errors = '';
              for (let i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              return alert('There was a problem with your form\n\n'+errors);
            }

            document.getElementsByClassName('contact-form')[0].reset();
            if(document.getElementsByClassName('contact-content').length){
              document.getElementsByClassName('contact-content')[0].classList.add('hidden');
              document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
              document.getElementsByClassName('contact-details-form')[0].scrollIntoView();
            } else {
              if(typeof Swal !== 'undefined'){
                return Swal.fire({
                  title: 'Thank you!',
                  text: 'Our team will be in touch soon!',
                  icon: 'success',
                  confirmButtonText: 'OK'
                });
              } else {
                return alert('Thank you!');
              }
            }

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'Contact Form Submit'
            });


          }).catch(function(err) {
            document.body.classList.add('loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });
        });
      });
    });
  }

  // Email Signup
  if(document.getElementById('email-signup')){

    if(document.querySelector('.newsletter-form input[name=g-recaptcha-response]').value==""){

      document.getElementById('email-signup').addEventListener("click", function(e) {
        e.preventDefault();

        document.getElementById('email-signup').classList.add('preload');
        // document.getElementById('email-signup').innerHTML = '<span class="btn-loading">Please wait<span>';
        document.getElementById('email-signup').disabled = true;

        grecaptcha.ready(function() {
          grecaptcha.execute(document.querySelector('.newsletter-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
            document.querySelector('.newsletter-form input[name=g-recaptcha-response]').value = recaptcha_token;

            var url = '/newsletter';
            var email = document.getElementById('newsletter-email').value;
            var name = document.getElementById('newsletter-name').value;
            // var surname = document.getElementById('newsletter-surname').value;
            var token = document.querySelector('.newsletter-form [name=_token]').value;
            var newsletter_recaptcha = document.querySelector('.newsletter-form input[name=g-recaptcha-response]').value;

            fetch(url, {
              method: 'POST', // or 'PUT'
              body: JSON.stringify({
                'name': name,
                // 'first_name': forename,
                // 'last_name': surname,
                'email': email,
                '_token': token,
                'g-recaptcha-response':newsletter_recaptcha
              }), // data can be `string` or {object}!
              headers:{
                'Content-Type': 'application/json'
              }}).then(function(response) {
              if (response.status !== 200) {
                console.warn('Looks like there was a problem. Status Code: ' +
                  response.status);
                return;
              }
              return response.json();
            }).then(function(data) {

              document.getElementById('email-signup').classList.remove('preload');
              // document.getElementById('email-signup').innerHTML = 'Signup';
              document.getElementById('email-signup').disabled = false;

              if(data.status!='ok'){
                let errors = '';
                for (let i in data.errors) {
                  errors += data.errors[i][0]+'\n';
                }
                grecaptcha.execute(document.querySelector('.newsletter-form').dataset['recaptcha'], {action: 'contact'}).then(function(token) {
                  document.querySelector('.newsletter-form input[name=g-recaptcha-response]').value = token;
                });
                if(typeof Swal !== 'undefined'){
                  return Swal.fire({
                    title: 'Whoops!',
                    html: ('There was a problem with your sign up details\n\n'+errors).replace(/\n/gi,'<br>'),
                    icon: 'error',
                    confirmButtonText: 'OK',
                  });
                } else {
                  return alert('There was a problem with your sign up details\n\n'+errors);
                }
              }

              document.getElementsByClassName('newsletter-form')[0].reset();
              // Trigger event tracking
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'Newsletter Signup'
              });

              if(typeof Swal !== 'undefined'){
                return Swal.fire({
                  title: 'Thank you!',
                  text: 'You\'re signed up!',
                  icon: 'success',
                  confirmButtonText: 'OK'
                });
              } else {
                return alert('Thank you!');
              }

            }).catch(function(err) {
              console.error('Fetch Error -', err);
              document.getElementById('email-signup').classList.remove('preload');
              // document.getElementById('email-signup').innerHTML = 'Signup';
              document.getElementById('email-signup').disabled = false;
            });

          });
        });

      });

    }

  }


  // Uncheck compliance checkboxes
  let checkboxes = document.querySelectorAll('form [name=consent]');
  if(checkboxes.length > 0) {
    checkboxes.forEach(value => {
      value.checked = false;
    })
  }



  // Hero Slider
  const heroSlider = document.querySelector('#hero-offer-wrapper > div:not(.glider-arrows)')
  if (heroSlider) {
    new Glider(heroSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '#hero-offer-wrapper .glider-prev',
        next: '#hero-offer-wrapper .glider-next'
      },
      responsive: [
        {
          breakpoint: 769,
          settings: {
            draggable: false,
          }
        }
      ]
    })
  }

});




window.onload = (function(){

  // Toggle Offer Filters
  document.getElementById('filter-btn') ? document.getElementById('filter-btn').addEventListener('click', (e) => {e.preventDefault();document.getElementById('filter-btn').classList.toggle('hidden');document.querySelector('#offer-filters').classList.toggle('hidden');}) : null;

  if(document.getElementsByName('search-type')[0].value=='van'){
    (document.querySelector('.search-van')) ? document.querySelector('.search-van').classList.add("active") : null;
  } else{
    (document.querySelector('.search-car')) ? document.querySelector('.search-car').classList.add("active") : null;
  }

  // Load Search Form
  if(document.getElementsByClassName('search-form').length>0){

    // Search
    let searchType = 'van';

    if(document.querySelector('#search-type')) {
      searchType = document.querySelector('#search-type').value;
    } else if(document.getElementsByName('search-type')) {
      searchType = document.getElementsByName('search-type')[0].value;
    } else {
      searchType = 'van';
    }
    // document.getElementsByName('search-type') ? document.getElementsByName('search-type')[0].value : 'van';
    if(searchType){
      loadBodyTypes(searchType);
      loadManufacturers(searchType);
    }

    document.querySelector('.search-form [name=search-type]').addEventListener("change", function(e){
      loadBodyTypes(searchType);
      loadManufacturers(searchType, e.target.value);
    });
    document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
      loadModels(searchType, e.target.value);
    });
    
    // if(document.querySelector('.full-header-intro .search-form [name=make]')!==null){
    //   document.querySelector('.full-header-intro .search-form [name=make]').addEventListener("change", function(e){ 
    //     loadModels((document.getElementsByName('search-type')[0].value=='car'?'car':'van'), e.target.value);
    //   });
    // }

    document.querySelector('.search-form [name=model]').addEventListener("change", function(e){ 
      loadSpecs(searchType, e.target.value);
    });
  }
  
});


/* Slide Function */
function slide(track, numSlides, offset, numShowingDesk, numShowingTablet, numShowingMobile, autoPlay, timeout, linkList, arrows, trackOffset) {

    // VARIABLES
    var track = track, // slider track
        numSlides = numSlides, // total number of slides calculated
        newOffset = offset, //set initial offset
        numShowingDesk = numShowingDesk,
        numShowingTablet = numShowingTablet,
        numShowingMobile = numShowingMobile,
        autoPlay = autoPlay, // should it slide on its own
        timeout = timeout, // auto slide delay
        linkList = linkList, // jump links to slides
        arrows = arrows,
        newSlideWidth = 100/numShowingDesk, // calculate the slide width from numShowing on desktop
        newNumShowing = numShowingDesk, // set current number of slides showing to desktop
        currentSlide = 0,
        newTrackOffset = trackOffset; //set initial slide to the first
        

    // wrap added in css in case broken... remove it initially
    track.style.flexWrap = 'nowrap';

    function setSizes(){
        //alert('setsizes');
        track.style.transform = 'translate('+newOffset+'%, 0)'; //add offset
        track.style.width = 'calc('+newSlideWidth*numSlides+'% + '+trackOffset+')';
    }

    function setMobileSizes(){
        track.style.transform = 'translate(0, 0)'; //remove offset
        track.style.width = 'calc('+newSlideWidth*numSlides+'% + '+trackOffset+')';
    }

    function setTabletSizes(){
        track.style.transform = 'translate(0, 0)'; //remove offset
        track.style.width = 'calc('+newSlideWidth*numSlides+'% + '+trackOffset+')';
    }


   
    // add click event to links
    if(typeof(linkList) != 'undefined' && linkList != null){
        var links = linkList.getElementsByClassName("slider-link");
        for (var i = 0; i < links.length; i++) {
            links[i].addEventListener('click', linkJump, false);
        }
    };

    if(typeof(arrows) != 'undefined' && arrows != null){
        arrows.querySelector('.prev').addEventListener('click', prevSlideClick, false);
        arrows.querySelector('.next').addEventListener('click', nextSlideClick, false);
    }

    track.parentElement.parentElement.querySelector('div.next').addEventListener('click', nextSlideClick, false);
    track.parentElement.parentElement.querySelector('div.prev').addEventListener('click', prevSlideClick, false);


    function linkJump(){
        var listElem = this.parentElement; //li of clicked
        var parent = listElem.parentNode; // ul
        var index = Array.prototype.indexOf.call(parent.children, listElem);
        currentSlide = index;
        updateSlide(index);
    }; 

    function updateButtons(i){
      let slideNum;
        slideNum = i;
        var listElem = linkList.querySelector("li:nth-of-type("+(slideNum+1)+")"); // li of clicked
        var parent = listElem.parentNode; // ul


        // SET BUTTON AS ACTIVE
        var allChildren = parent.children; //all li's
        var totalWidth = 0; // width of total li's

        for (var i = 0; i < allChildren.length; i++) {
            allChildren[i].classList.remove("active"); // remove active from all li's
            totalWidth = totalWidth + allChildren[i].offsetWidth; // add total width of all li's
        }

        listElem.classList.add("active"); // set active on clicked li

        // UPDATE SLIDER POSITION
        // if width of links is longer than its container, scroll to the start on click (mobile)
        if(totalWidth > parent.offsetWidth){
            if(listElem.offsetLeft < (totalWidth - parent.offsetWidth)){ // check if the last element is offscreen
                var leftAmount = listElem.offsetLeft*-1;
                parent.style.transform = 'translate('+leftAmount+'px, 0)';
            }
            
        } else {
            parent.style.transform = 'translate(0px, 0)'; //else reset to start
        }
    }
        

    function updateSlide(i){
      let slideNum, translateAmount;
        slideNum = i;
        translateAmount = slideNum * -(100/numSlides)+newOffset+'%';
        track.style.transform = 'translate('+translateAmount+', 0)';
        currentSlide = slideNum;

        if(typeof(linkList) != 'undefined' && linkList != null){
            updateButtons(currentSlide);
        }
    };

    function nextSlide(){
        if(currentSlide < numSlides-newNumShowing){
            updateSlide(currentSlide+1);
        } else {
            updateSlide(0)
        }
    }

    function prevSlide(){
        if(currentSlide > 0){
            updateSlide(currentSlide-1);
        }
    }

    function nextSlideClick(){
        autoPlay = false;
        nextSlide();
    }

    function prevSlideClick(){
        autoPlay = false;
        prevSlide();
    }

    
    function autoSlide() {

        var int = setInterval((function() {
            
            // if all characters were used
            if (autoPlay === false) {
                clearInterval(int);
                return;
            }
            nextSlide()
        }), timeout);
    }
    if(autoPlay == true){
       autoSlide(); 
    }


    // track.swipeDetector()
    //     .on("swipeLeft.sd swipeRight.sd swipeUp.sd swipeDown.sd", function(event) {
    //         if (event.type === "swipeLeft") {
    //             nextSlide();
    //         } else if (event.type === "swipeRight") {
    //             prevSlide();
    //         }
    // });

    // window resize
    window.addEventListener('resize', function(event){
      // do stuff here
      if(window.innerWidth <= 768){
            newOffset = 0; // remove offset on mobile
            newNumShowing = numShowingMobile;
            newSlideWidth = 100/numShowingMobile; //set to 100 on mobile

            setMobileSizes();
        } else if(window.innerWidth <= 1280){
            newOffset = 0; // remove offset on tablet
            newNumShowing = numShowingTablet;
            newSlideWidth = 100/numShowingTablet; //set to 50 on taablet
            
            setTabletSizes();
        } else {
            newOffset = offset;
            newNumShowing = numShowingDesk;
            newSlideWidth = 100/numShowingDesk;
            
            setSizes();
        }
    });

    setSizes();
    window.dispatchEvent(new Event('resize'));
}
/* END SLIDER */


// efficient debounce resize https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
var myEfficientFn = debounce(function() {
  if(window.innerWidth <= 1024){
    mobileDerrivative();
    window.responsive = 'touch';
  } else {
    desktopDerrivative();
    window.responsive = 'desktop';
  }
}, 250);
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
window.addEventListener('resize', myEfficientFn);
myEfficientFn();





function mobileDerrivative(){
  if(window.responsive !== 'touch' && document.querySelector(".deal-gallery")){
    let tabcontent, tablinks;
    //tabs
    document.querySelectorAll(".tab")[0].after(document.getElementById("standard-equipment"));
    document.querySelectorAll(".tab")[1].after(document.getElementById("technical-data"));
    if (document.getElementById("review-panel")) {
      document.querySelectorAll(".tab")[2].after(document.getElementById("review-panel"));
    }

    document.querySelector(".deal-gallery").after(document.querySelector(".deal-aside"));

    tabcontent = document.querySelectorAll(".tab");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].className = tabcontent[i].className.replace(" active", "");
    }
    tablinks = document.querySelectorAll(".tab-content");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
  }
}

function desktopDerrivative(){
  if(window.responsive !== 'desktop' &&  document.querySelector(".deal-gallery")){
    //tabs
    
    if (document.getElementById("review-panel")) {
      document.querySelector(".tab-list").after(document.getElementById("review-panel"));
    }
    document.querySelector(".tab-list").after(document.getElementById("technical-data"));
    document.querySelector(".tab-list").after(document.getElementById("standard-equipment"));

    document.querySelector(".deal-main").after(document.querySelector(".deal-aside"));
    
    document.querySelectorAll(".tab")[0].classList.add("active");
    document.querySelectorAll(".tab-content")[0].classList.add("active");
    console.log(document.querySelectorAll(".tab-content")[1]);
  }
}


// gallery slider

function slideThumbnail(track, numSlides, offset, slideWidth, numShowing, autoPlay, timeout) {

    var newOffset = offset;
    var newSlideWidth = slideWidth;
    var currentSlide=0; //set initial slide to the first
    var autoPlay = autoPlay;
    var timeout = timeout;
    var newNumShowing = numShowing;

    function setSizes(){
        //alert('setsizes');
        track.style.transform = 'translate('+newOffset+'%, 0)'; //add offset
        track.style.width = newSlideWidth*numSlides+'%';
    }
    function setMobileSizes(){
        track.style.transform = 'translate(0, 0)'; //remove offset
        track.style.width = newSlideWidth*numSlides+'%';
    }

    var thumbs = document.querySelectorAll(".thumbnail a");

    for(var i = 0; i < thumbs.length; i++){
        thumbs[i].addEventListener('click', function(event){
            var li = this.parentNode;
            var ul = this.closest('ul');
            var nodes = Array.from(ul.children);
            var index = nodes.indexOf(li);
            updateSlide(index);
            event.preventDefault();
        }, false);
    }

    function updateSlide(i){
      let slideNum, url, translateAmount;
        // console.log('updateSlide '+i);
        slideNum = i;

        //update image
        url = document.querySelector('.thumbnail:nth-child('+(slideNum+1)+') img').src;
        document.getElementById("main-img").src = url; 

        //slide to right spot on thumbnails
        // console.log(slideNum+' of '+numSlides);
        if((slideNum<(numSlides-2)) && (slideNum>1)){
            translateAmount = (slideNum-2) * -(100/numSlides)+newOffset+'%';
            // console.log('slide')
        } else if(slideNum < 2){
            // console.log('<2');
            translateAmount = 0+newOffset+'%';
        } else{
            translateAmount = (numSlides-newNumShowing) * -(100/numSlides)+newOffset+'%';
            // console.log('dont slide');
        }
        track.style.transform = 'translate('+translateAmount+', 0)';

        //add active class


        currentSlide = slideNum;
    };

    function nextSlide(){
        if(currentSlide < numSlides-newNumShowing){
            updateSlide(currentSlide+1);
        } else {
            updateSlide(0)
        }
    }

    function prevSlide(){
        if(currentSlide > 0){
            updateSlide(currentSlide-1);
        }
    }

    function nextSlideClick(){
        autoPlay = false;
        nextSlide();
    }

    function prevSlideClick(){
        autoPlay = false;
        prevSlide();
    }

    track.parentElement.parentElement.querySelector('a.next').addEventListener('click', nextSlideClick, false);
    track.parentElement.parentElement.querySelector('a.prev').addEventListener('click', prevSlideClick, false);

    function autoSlide() {
        var int = setInterval((function() {
            
            // if all characters were used
            if (autoPlay === false) {
                clearInterval(int);
                return;
            }
            nextSlide()
        }), timeout);
    }

    if(autoPlay == true){
       autoSlide(); 
    }

    setSizes();
    window.dispatchEvent(new Event('resize'));
}
/* END SLIDER */
